import {
  ReceiptList,
  RecurrentContact,
  ScreenGreeting,
  DateFilter,
} from "../../../Components/Molecules";
import { LinkButton } from "../../../Components/Atoms";

import { useTransactionsData } from "../../../Hooks";
import { useEffect, useState } from "react";
import { QrCode, BarChart, Payment, ContentCopy } from "@mui/icons-material";
import { ReturnPixModal } from "../../../Components/Molecules/ReturnPixModal";
import { ModalLoader } from "../../../Components/Atoms/ModalLoader";
import { Box, Paper, Stack, useMediaQuery } from "@mui/material";
import { useAuth } from "../../../Contexts/AuthContext";
import { TableFilter } from "../../../Components/Molecules/Filters";
import { useFilter } from "../../../Hooks/useFilter";

export const PixArea = () => {
  const qrCode = sessionStorage.getItem("@BCBankline:Qrcode");
  const [returnPixModal, setReturnPixModal] = useState(false);
  const {
    state: transactionsData,
    handleGET: fetchTransactionsGET,
    loading: transactionsLoading,
  } = useTransactionsData();
  const matches = useMediaQuery("(min-width: 1220px)");

  const { hasPermission } = useAuth();
  const { getFilterObj } = useFilter();
  // Use a Pix-only filter namespace to evitar impacto em outras telas
  const pixFilterObj = getFilterObj("pixStatement");

  const handleSetToFirstPage = () => {
    // No pagination on PixArea list; refetching is handled by useEffect on filter change
    return;
  };

  useEffect(() => {
    const queryParameters = {
      limit: 5,
      product: "pix",
      ...pixFilterObj,
    };
    fetchTransactionsGET(queryParameters);
    //CHAMA LISTA DE DEVOLUÇÔES
  }, [pixFilterObj]);

  return (
    <>
      <ModalLoader
        loading={transactionsLoading.GET}
        text={"Carregando informações"}
      />
      <ScreenGreeting
        title={"Minha área Pix"}
        subTitle={
          "Envie, receba e acompanhe suas transações Pix com praticidade"
        }
      />
      <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2} mb={2} mt={0}>

        {
          hasPermission('paypix') && (
            <>
              <LinkButton
                path={"pix/transferencia"}
                icon={<Payment />}
                tooltip="Enviar um Pix"
              >
                Transferir
              </LinkButton>
            </>
          )
        }

        {
          hasPermission('receivepix') && (
            <LinkButton
              path={"/pix/vendas"}
              icon={<QrCode />}
              tooltip="Receber por Pix"
            >
              Gerar cobrança
            </LinkButton>
          )
        }

        
        {
          hasPermission('pixview') && (
            <LinkButton
              path={"/pix/detalhes"}
              icon={<BarChart />}
              tooltip="Ver detalhes do Pix"
            >
              Detalhes PIX
            </LinkButton>
          )
        }
      </Stack>
      {/* Apply the same filters used on /transferencia */}
      <Box>
        <TableFilter tableName="pixStatement" setPageToFirst={handleSetToFirstPage} />
      </Box>
      <Paper sx={{ mt: 2 }}>
        <Box px={2} pt={2} pb={1}
          sx={{ display: 'flex', flexDirection: matches ? 'row' : 'column' }}
        >
          {transactionsData !== undefined && (
            <DateFilter
              tableName={"pixStatement"}
              setPageToFirst={handleSetToFirstPage}
              hasData={Object.keys(transactionsData || {}).length > 0}
            />
          )}
        </Box>
        <ReceiptList
          headerLink={"/extrato"}
          itens={transactionsData}
          product={"pix"}
          type="pix"
          hasFilter
          title={"Meu extrato"}
        />
      </Paper>
      <ReturnPixModal
        open={returnPixModal}
        onClose={() => {
          setReturnPixModal(!returnPixModal);
        }}
      />
    </>
  );
};
